import React, { Component } from 'react';
import { QRCodeCanvas } from '@cheprasov/qrcode';
import CryptoJS from 'crypto-js';
import numeral from 'numeral';
import { saveAs } from 'file-saver';

import { localizedText } from '../../../i18n';

import {
  genPayData2,
  isWexin,
  isAlipay,
  isNumeric,
  isMobile,
  isiOS
} from '../../../utils';

import wechatLogo from '../../../assets/ic_wechat.svg';
import aliLogo from '../../../assets/ic_alipay.svg';
import moneymoreLogo from '../../../assets/ic_latipay.svg';
import polipayLogo from '../../../assets/ic_bankpay.svg';
import unionpayLogo from '../../../assets/ic_upi_qr_code.svg';
import azupayLogo from '../../../assets/ic_azupay.svg';
import coinLogo from '../../../assets/ic_coin_payments.svg';

import selectedLogo from '../../../assets/ic_selected.svg';
import unselectedLogo from '../../../assets/ic_unselected.svg';

import helpLogo from '../../../assets/ic_help.svg';

import infoImg from '../../../assets/ic_info.svg';
import api from '../../../api';

import Footer from '../../../components/SupportbyFooter';

import './index.css';

const env = process.env.REACT_APP_DEPLOY_ENV || 'staging';

const REACT_APP_ROOT_URL = process.env.REACT_APP_ROOT_URL || '';

const icons = {
  wechat: wechatLogo,
  alipay: aliLogo,
  latipay: moneymoreLogo,
  polipay: polipayLogo,
  upi_qr_code: unionpayLogo,
  azupay: azupayLogo,
  coin_payments: coinLogo
};

const titles = {
  wechat: 'WeChat Pay',
  alipay: 'Alipay',
  latipay: 'MoneyMore',
  polipay: 'NZ bank account',
  upi_qr_code: 'UnionPay',
  azupay: 'PayID',
  coin_payments: 'Crypto'
};

//优先级别第一个
const priorities = {
  wechat: ['wechat', 'polipay', 'latipay', 'alipay', 'upi_qr_code'],
  alipay: ['alipay', 'polipay', 'latipay', 'wechat', 'upi_qr_code'],
  mobile: ['polipay', 'latipay', 'alipay', 'wechat', 'upi_qr_code'],
  pc: ['polipay', 'latipay', 'alipay', 'wechat', 'upi_qr_code']
};

function firstGateway(gateways) {
  const availableGateways = gateways.filter(item => !item.disabled);

  const map = availableGateways.reduce(
    (result, item) => ({ ...result, [item.name]: item }),
    {}
  );

  const params = new URLSearchParams(window.location.search);
  const gateway = params.get('gateway'); //优先选中历史
  if (gateway && map[gateway]) {
    return map[gateway];
  }

  let priority = 'pc';
  if (isWexin) {
    priority = 'wechat';
  } else if (isAlipay) {
    priority = 'alipay';
  } else if (isMobile()) {
    priority = 'mobile';
  }

  for (const gateway of priorities[priority]) {
    const g = map[gateway];

    if (g) {
      return g;
    }
  }

  return availableGateways[0];
}

const svg1 = `<svg width="33px" height="33px" viewBox="0 0 469 469" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <polygon id="path-1" points="0 0.387 468.613 0.387 468.613 468.94 0 468.94"></polygon>
            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="worldwide">
                    <g id="Group-3">
                        <mask id="mask-2" fill="white">
                            <use xlink:href="#path-1"></use>
                        </mask>
                        <g id="Clip-2"></g>
                        <path d="M234.306,26.912 C119.735,26.912 26.525,120.122 26.525,234.694 C26.525,349.265 119.735,442.475 234.306,442.475 C348.879,442.475 442.089,349.265 442.089,234.694 C442.089,120.122 348.879,26.912 234.306,26.912 Z M234.306,469 C105.111,469 0,363.894 0,234.694 C0,105.498 105.111,0.387 234.306,0.387 C363.507,0.387 468.614,105.498 468.614,234.694 C468.614,363.894 363.507,469 234.306,469 Z" id="Fill-1" fill="#5F605C" mask="url(#mask-2)"></path>
                    </g>
                    <path d="M92.41,77.629 C131.557,113.257 181.862,132.77 235.072,132.77 C288.286,132.766 338.595,113.252 377.738,77.629 C338.595,42.005 288.286,22.492 235.072,22.492 C181.858,22.492 131.552,42.005 92.41,77.629 Z M235.072,150.454 C174.125,150.454 116.693,126.824 73.351,83.915 C71.676,82.257 70.73,79.994 70.73,77.633 C70.73,75.272 71.671,73.013 73.351,71.351 C116.685,28.437 174.116,4.808 235.072,4.808 C296.027,4.808 353.463,28.437 396.797,71.347 C398.471,73.009 399.418,75.272 399.418,77.629 C399.418,79.985 398.471,82.248 396.797,83.91 C353.463,126.82 296.027,150.45 235.072,150.454 Z" id="Fill-4" fill="#5F605C"></path>
                    <path d="M96.601,395.411 C135.142,428.682 183.948,446.896 235.076,446.896 C286.204,446.896 335.01,428.682 373.555,395.411 C335.006,362.148 286.199,343.929 235.072,343.929 C183.944,343.929 135.142,362.139 96.601,395.411 Z M235.076,464.579 C176.216,464.579 120.195,442.298 77.339,401.838 C75.57,400.167 74.567,397.846 74.567,395.411 C74.567,392.975 75.57,390.654 77.339,388.983 C120.195,348.527 176.212,326.25 235.072,326.25 C293.935,326.25 349.957,348.527 392.822,388.983 C394.59,390.654 395.593,392.975 395.593,395.411 C395.593,397.846 394.59,400.167 392.822,401.838 C349.962,442.298 293.94,464.579 235.076,464.579 Z" id="Fill-5" fill="#5F605C"></path>
                    <polygon id="Fill-6" fill="#5F605C" points="4.533 243.545 464.533 243.545 464.533 225.545 4.533 225.545"></polygon>
                    <path d="M234.32,22.492 C199.824,22.492 161.389,109.64 161.389,234.694 C161.389,359.747 199.824,446.896 234.32,446.896 C268.816,446.896 307.252,359.747 307.252,234.694 C307.252,109.64 268.816,22.492 234.32,22.492 Z M234.32,464.579 C183.506,464.579 143.705,363.602 143.705,234.694 C143.705,105.785 183.506,4.808 234.32,4.808 C285.133,4.808 324.935,105.785 324.935,234.694 C324.935,363.602 285.133,464.579 234.32,464.579 Z" id="Fill-7" fill="#5F605C"></path>
                    <path d="M305.805,102.483 C320.86,102.483 333.065,114.687 333.065,129.742 C333.065,144.797 320.86,157.001 305.805,157.001 C290.751,157.001 278.547,144.797 278.547,129.742 C278.547,114.687 290.751,102.483 305.805,102.483" id="Fill-8" fill="#FFFFFE"></path>
                    <path d="M305.81,111.342 C295.655,111.342 287.392,119.605 287.392,129.76 C287.392,139.914 295.655,148.177 305.81,148.177 C315.965,148.177 324.227,139.914 324.227,129.76 C324.227,119.605 315.965,111.342 305.81,111.342 Z M305.81,165.861 C285.903,165.861 269.71,149.667 269.71,129.76 C269.71,109.852 285.903,93.659 305.81,93.659 C325.717,93.659 341.911,109.852 341.911,129.76 C341.911,149.667 325.717,165.861 305.81,165.861 Z" id="Fill-9" fill="#91928E"></path>
                    <path d="M304.855,319.412 C319.913,319.412 332.119,331.618 332.119,346.674 C332.119,361.732 319.913,373.938 304.855,373.938 C289.798,373.938 277.591,361.732 277.591,346.674 C277.591,331.618 289.798,319.412 304.855,319.412" id="Fill-10" fill="#FFFFFE"></path>
                    <path d="M304.855,328.248 C294.696,328.248 286.433,336.511 286.433,346.67 C286.433,356.829 294.696,365.092 304.855,365.092 C315.014,365.092 323.277,356.829 323.277,346.67 C323.277,336.511 315.014,328.248 304.855,328.248 Z M304.855,382.776 C284.948,382.776 268.75,366.578 268.75,346.67 C268.75,326.763 284.948,310.565 304.855,310.565 C324.762,310.565 340.961,326.763 340.961,346.67 C340.961,366.578 324.762,382.776 304.855,382.776 Z" id="Fill-11" fill="#91928E"></path>
                    <path d="M152.534,207.434 C167.589,207.434 179.793,219.639 179.793,234.694 C179.793,249.748 167.589,261.953 152.534,261.953 C137.479,261.953 125.275,249.748 125.275,234.694 C125.275,219.639 137.479,207.434 152.534,207.434" id="Fill-12" fill="#FFFFFE"></path>
                    <path d="M152.551,216.276 C142.397,216.276 134.134,224.539 134.134,234.694 C134.134,244.848 142.397,253.111 152.551,253.111 C162.706,253.111 170.969,244.848 170.969,234.694 C170.969,224.539 162.706,216.276 152.551,216.276 Z M152.551,270.794 C132.644,270.794 116.45,254.601 116.45,234.694 C116.45,214.787 132.644,198.593 152.551,198.593 C172.459,198.593 188.652,214.787 188.652,234.694 C188.652,254.601 172.459,270.794 152.551,270.794 Z" id="Fill-13" fill="#91928E"></path>
                </g>
            </g>
        </svg>`;

const isiOSPlatform = isiOS();

export default class Page extends Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(window.location.search);

    const particulars =
      params.get('particulars') || sessionStorage.getItem('particulars') || '';
    const referenceCode =
      params.get('referenceCode') ||
      sessionStorage.getItem('referenceCode') ||
      '';
    const reference =
      params.get('reference') || sessionStorage.getItem('reference') || '';

    let amount =
      params.get('amount') ||
      sessionStorage.getItem('amount') ||
      sessionStorage.getItem('amount_from_preview_page') ||
      ''; //手机扫pc码  || back from preview

    sessionStorage.removeItem('particulars');
    sessionStorage.removeItem('referenceCode');
    sessionStorage.removeItem('reference');
    sessionStorage.removeItem('amount');
    sessionStorage.removeItem('amount_from_preview_page');

    if (!isNumeric(amount) || amount <= 0) {
      amount = '';
    }

    const currency = params.get('currency');

    this.state = {
      amount,
      referenceOpened: true, //!!(particulars || referenceCode || reference),
      data: {
        amount,
        currency,
        gateways: [
          {
            id: 2,
            name: 'wechat',
            iconUrl: null,
            balance: null,
            // charge: 2.3,
            // maxCharge: 0.3,
            // minCharge: 0.2,
            fixedFee: 0,
            bankId: null,
            bank: null,
            accountNumber: null,
            verified: null,
            clientIpCountry: null
          },
          {
            id: 1,
            name: 'alipay',
            iconUrl: null,
            balance: null,
            // charge: 2.3,
            // maxCharge: 0,
            // minCharge: 0,
            fixedFee: 0,
            bankId: null,
            bank: null,
            accountNumber: null,
            verified: null
            // clientIpCountry: 'NZ'
          }
        ]
      },

      particulars,
      referenceCode,
      reference,

      selectGateway: null,
      placeholder: 'Input amount',

      openInSafari: sessionStorage.getItem('openInSafari') || false
    };

    sessionStorage.removeItem('openInSafari');

    this.amountRef = React.createRef();

    this.referenceParticularRef = React.createRef();
    this.referenceCodeRef = React.createRef();
    this.referenceRef = React.createRef();
  }

  /*
  async componentDidMount() {
    const { organisationCode, shortCode } = this.props.match.params;

    const { data } = await api.staticQR.getWalletInfoByCompany(
      organisationCode,
      shortCode
    );

    if (data.code === 0) {
      const rates = data.rates || [];

      // if (window.location.href.indexOf(':3000') !== -1) {
      //   data.currentPaidAmount = 100;
      //   data.maximumPaidAmount = 200;
      //   data.currentPaidCount = 1;
      //   data.maximumPaidCount = 3;
      // }

      const gatewayMap = data.gateways.reduce(
        (result, item) => ({
          ...result,
          [item.name]: true
        }),
        {}
      );

      if (data.maximumPaidAmount) {
        const array = [...data.gateways];
        if (!gatewayMap.wechat) {
          array.push({
            name: 'wechat',
            disabled: true
          });
        }
        if (!gatewayMap.alipay) {
          array.push({
            name: 'alipay',
            disabled: true
          });
        }
        data.gateways = array;
      }

      const selectGateway = firstGateway(data.gateways || []);
      this.setState(pre => ({
        data: {
          ...data,
          rates: rates.reduce(
            (result, item) => ({
              ...result,
              [item.sourceType.toLowerCase()]: item.rate
            }),
            {}
          )
        },
        referenceOpened: true,
        // (data.referenceTemplate &&
        //   (data.referenceTemplate.particularsRequired ||
        //     data.referenceTemplate.codeRequired ||
        //     data.referenceTemplate.referenceRequired)) ||
        // pre.referenceOpened,
        selectGateway,
        gateway: selectGateway.name,
        amount: data.amount || pre.amount || ''
      }));
    } else if (data.code === 221 && data.amount && data.status) {
      window.location =
        window.location.origin +
        `${REACT_APP_ROOT_URL}/result?status=${data.status}&amount=${
          data.amount
        }`;
    } else {
      alert(data.message || data.messageCN || 'Invalid QR code');
    }
  }
*/
  isForSaveQRCode = () => {
    const { gateway } = this.state;

    //仅安卓保存图片到本地
    return gateway === 'wechat' && !isiOSPlatform && isMobile() && !isWexin;
  };

  downloadQRCode = async () => {
    const { particulars, referenceCode, reference, amount, data } = this.state;
    const { qrName } = data || {};
    if (!qrName) {
      return;
    }

    const {
      currentPaidCount,
      maximumPaidCount,
      currentPaidAmount,
      maximumPaidAmount
    } = data || {};

    const limited =
      maximumPaidAmount &&
      (currentPaidCount >= maximumPaidCount ||
        currentPaidAmount >= maximumPaidAmount);
    if (limited) {
      return;
    }

    if (
      maximumPaidAmount &&
      amount &&
      numeral(amount)
        .add(currentPaidAmount)
        .value() > maximumPaidAmount
    ) {
      alert(
        'This Merchant has not yet verified or activated their account. Please contact merchant.'
      );
      return;
    }

    const { accountCode, userCode } = data;
    if (!accountCode || !userCode) {
      alert('Invalid QR code');
      return;
    }

    const msg = this.validData();
    if (msg) {
      return;
    }
    //

    let url = `${window.location.origin +
      window.location.pathname}?amount=${amount}`;

    if (particulars) url += `&particulars=${particulars}`;
    if (referenceCode) url += `&referenceCode=${referenceCode}`;
    if (reference) url += `&reference=${reference}`;

    const qrCanvas = new QRCodeCanvas(url, { level: 'H', size: 300 });
    const dataUrlWithQRCode = await qrCanvas.toDataUrl();
    //

    const filename = `${qrName}_${amount}`.replace(/[^a-z0-9]/gi, '_');
    saveAs(dataUrlWithQRCode, filename);

    // const link = document.createElement('a');
    //
    // link.setAttribute('download', `${filename}.png`);
    // link.setAttribute('href', dataUrlWithQRCode);
    // link.click();
  };

  submit = async () => {
    const {
      data,
      particulars,
      referenceCode,
      reference,
      amount,
      selectGateway
    } = this.state;

    const {
      currentPaidCount,
      maximumPaidCount,
      currentPaidAmount,
      maximumPaidAmount
    } = data || {};

    const limited =
      maximumPaidAmount &&
      (currentPaidCount >= maximumPaidCount ||
        currentPaidAmount >= maximumPaidAmount);
    if (limited) {
      return;
    }

    if (
      maximumPaidAmount &&
      amount &&
      numeral(amount)
        .add(currentPaidAmount)
        .value() > maximumPaidAmount
    ) {
      alert(
        'This Merchant has not yet verified or activated their account. Please contact merchant.'
      );
      return;
    }

    const { accountCode, userCode, currency } = data;
    if (!accountCode || !userCode) {
      // alert('Invalid QR code');
      // return;
    }

    const gateway = (selectGateway && selectGateway.name) || '';

    const msg = this.validData();
    if (msg) {
      return;
    }
    ////

    const ref = this.validReference();
    if (ref) {
      // this.setState(
      //   pre => ({
      //     referenceOpened: true
      //   }),
      //   () => {
      if (ref.current) {
        ref.current.focus();
      }
      // }
      // );
      return;
    }

    if (gateway === 'polipay' && amount < 1) {
      alert('Minimum amount for Polipay is $1');
      return;
    }

    //
    this.setState({
      submitting: true
    });
    const params = new URLSearchParams(window.location.search);
    const apiKey = params.get('api_key');
    const user_id = params.get('user_id');
    const wallet_id = params.get('wallet_id');
    const merchant_reference = params.get('merchant_reference');
    const product_name = params.get('product_name');
    const callback_url = params.get('callback_url');
    const return_url = params.get('return_url');

    const body = {
      user_id,
      wallet_id,
      amount,
      payment_method: gateway,
      return_url:
        return_url || `${window.location.origin}/static_qr_confirmation`,
      callback_url,
      merchant_reference,
      ip: '192.168.1.1',
      version: '2.0',
      product_name,
      host_type: '1'
    };

    const message = Object.keys(body)
      .filter(
        item =>
          body[item] != null && body[item] != undefined && body[item] !== ''
      )
      .sort()
      .map(item => `${item}=${body[item]}`)
      .join('&')
      .concat(apiKey);

    body.signature = CryptoJS.HmacSHA256(message, apiKey).toString();

    const { data: order } = await api.transaction.makeOffline(body);
    if (order.code === 0) {
      const { host_url, nonce } = order;
      const url = host_url + '/' + nonce;
      const { data } = await api.transaction.nonce(url);
      if (data.code === 0 && data.data && data.data.qr_code) {
        const { order_id, qr_code } = data.data;
        sessionStorage.setItem('paymentQRCode', qr_code);

        let url = `${
          window.origin
        }${REACT_APP_ROOT_URL}/offlineapi/preview?amount=${amount}&gateway=${gateway}&currency=${currency}&order_id=${order_id}`;

        window.location = url;
      } else {
        alert(data.message || 'Does not support yet.');
      }
    } else {
      alert(data.message || 'Does not support yet.');
    }

    this.setState({
      submitting: false
    });
    return;

    const { organisationCode, shortCode } = this.props.match.params;

    function gotoQrCodePage() {
      let url = `${
        window.origin
      }${REACT_APP_ROOT_URL}/${organisationCode}/${shortCode}/preview?amount=${amount}&gateway=${gateway}`;

      if (particulars) url += `&particulars=${particulars}`;
      if (referenceCode) url += `&referenceCode=${referenceCode}`;
      if (reference) url += `&reference=${reference}`;

      window.location = url;
    }

    sessionStorage.setItem('amount', amount); //为了返回时 恢复当前输入金额

    if (
      isMobile() ||
      gateway === 'polipay' ||
      gateway === 'upi_qr_code' ||
      gateway === 'azupay' ||
      gateway === 'coin_payments' ||
      (gateway === 'wechat' && isWexin) //微信Pad版本
    ) {
      const payData = genPayData2(
        { amount, reference, qr_code_id: data.id },
        {
          user_id: userCode,
          wallet_id: accountCode,
          payment_method: gateway,
          currency,
          returnUrl: `${window.location.origin}${REACT_APP_ROOT_URL}/result`
        },
        {
          particulars,
          referenceCode,
          reference
        }
      );

      if (isWexin && (gateway === 'latipay' || gateway === 'alipay')) {
        sessionStorage.setItem('openInSafari', true);

        let url = `${window.location.origin +
          window.location.pathname}?amount=${amount}&gateway=${gateway}`;

        if (particulars) url += `&particulars=${particulars}`;
        if (referenceCode) url += `&referenceCode=${referenceCode}`;
        if (reference) url += `&reference=${reference}`;

        window.location = url;
        return;
      }

      if (gateway === 'latipay') {
        const back = encodeURIComponent(window.location.href);

        let url = `https://m${
          env === 'staging' ? '-staging' : ''
        }.latipay.net/pay?type=qrcode&organisationCode=${organisationCode}&shortCode=${shortCode}&amount=${amount}&back=${back}`;
        if (particulars) url += `&particulars=${particulars}`;
        if (referenceCode) url += `&referenceCode=${referenceCode}`;
        if (reference) url += `&reference=${reference}`;

        window.location = url;
        return;
      } else if (gateway === 'wechat') {
        if (!isWexin) {
          gotoQrCodePage();
          return;
        }
      }

      this.setState({
        submitting: true
      });
      api.transaction.init(payData);
    } else {
      gotoQrCodePage();
    }
  };

  validData = () => {
    const {
      amount,
      // data,
      // particulars,
      // referenceCode,
      // reference,
      selectGateway
    } = this.state;
    // const { referenceTemplate } = data;

    if (!amount) {
      this.setState(
        {
          amountError: true
        },
        () => {
          this.amountRef.current.focus();
        }
      );
      return 'Please input amount';
    }

    const value = numeral(amount).value();

    if (value <= 0) {
      this.setState(
        {
          amountError: true
        },
        () => {
          this.amountRef.current.focus();
        }
      );
      return localizedText('staticqr.minimum');
    } else if (value >= 1000000) {
      this.setState(
        {
          amountError: true
        },
        () => {
          this.amountRef.current.focus();
        }
      );
      return localizedText('staticqr.maxmum');
    }

    const gateway = (selectGateway && selectGateway.name) || '';
    if (!gateway) {
      return 'Please select payment method';
    }
  };

  validReference = () => {
    const { data, particulars, referenceCode, reference } = this.state;
    const { referenceTemplate } = data;

    // return this.referenceRef;

    const {
      particularsRequired,
      codeRequired,
      referenceRequired

      // particularsHint,
      // codeHint,
      // referenceHint
    } = referenceTemplate || {};

    let ref;
    const state = {};
    if (referenceRequired && !reference) {
      // state.referenceOpened = true;
      state.referenceError = true;
      // return referenceHint || 'Need Reference';
      ref = this.referenceRef;
    }

    if (codeRequired && !referenceCode) {
      // state.referenceOpened = true;
      state.referenceCodeError = true;

      // return codeHint || 'Need Code';
      ref = this.referenceCodeRef;
    }

    if (particularsRequired && !particulars) {
      // state.referenceOpened = true;
      state.referenceParticularError = true;

      ref = this.referenceParticularRef;
      // return particularsHint || 'Need Particulars';
    }

    if (ref) {
      this.setState(state);
    }

    return ref;
  };

  select = gateway => () => {
    this.setState({
      gateway: gateway.name,
      selectGateway: gateway,
      showHelp: false
    });
  };

  change = key => e => {
    const { gateway } = this.state;

    if (key === 'amount') {
      const value = e.target.value || '';

      this.setState(({ amount = '' }) => {
        const index = value.indexOf('.');
        if (
          index === -1 ||
          `${value}`.length - index <= (gateway === 'coin_payments' ? 6 : 3)
        ) {
          return { [key]: value, amountError: false };
        } else {
          return { amountError: false };
        }
      });
    } else {
      const state = { [key]: e.target.value };
      if (key === 'particulars') {
        state.referenceParticularError = false;
      } else if (key === 'referenceCode') {
        state.referenceCodeError = false;
      } else if (key === 'reference') {
        state.referenceError = false;
      }

      this.setState(state);
    }
  };

  openReference = () => {
    //   this.setState(pre => ({
    //     referenceOpened: !pre.referenceOpened
    //   }));
  };

  goBack = () => {
    this.setState({
      preview: false
    });
  };

  onBlur = () => {
    this.setState({
      placeholder: 'Input amount'
    });
  };

  onFocus = () => {
    this.setState({
      placeholder: ''
    });
  };

  showHelp = () => {
    this.setState(pre => ({
      showHelp: !pre.showHelp
    }));
  };

  render() {
    const {
      referenceOpened,
      particulars,
      referenceCode,
      reference,
      data,
      amount,
      selectGateway,
      placeholder,
      showHelp,
      openInSafari,
      showAlipayLimitError,
      submitting
    } = this.state;

    const {
      amountError,
      referenceParticularError,
      referenceCodeError,
      referenceError
    } = this.state;

    const gateway = (selectGateway && selectGateway.name) || '';

    const {
      amount: fixedAmount,
      referenceTemplate,
      gateways = [],
      qrName,
      currency,
      payerReference
    } = data;

    const rate =
      data.rates && gateway !== 'coin_payments' && data.rates[gateway];

    const {
      particularsRequired,
      codeRequired,
      referenceRequired,
      particularsHint,
      codeHint,
      referenceHint
    } = referenceTemplate || {};

    let referenceDone = true;
    if (particularsRequired && !particulars) {
      referenceDone = false;
    } else {
      if (codeRequired && !referenceCode) {
        referenceDone = false;
      } else {
        if (referenceRequired && !reference) {
          referenceDone = false;
        }
      }
    }

    const {
      currentPaidCount,
      maximumPaidCount,
      currentPaidAmount,
      maximumPaidAmount,
      accountCode
    } = data || {};

    const limited =
      maximumPaidAmount &&
      (currentPaidCount >= maximumPaidCount ||
        currentPaidAmount >= maximumPaidAmount ||
        (amount &&
          numeral(amount)
            .add(currentPaidAmount)
            .value() > maximumPaidAmount));

    const enabled =
      !!(
        amount &&
        isNumeric(amount) &&
        selectGateway &&
        amount > 0 &&
        referenceDone &&
        !limited
      ) && !submitting;

    const needReference =
      particularsRequired ||
      particularsHint ||
      codeRequired ||
      codeHint ||
      referenceRequired ||
      referenceHint;

    const hideFeeTips =
      accountCode === 'W000000670' ||
      accountCode === 'W000001414' ||
      accountCode === 'W000045170';

    return (
      <div className="pg pg-staticqr">
        {limited && (
          <div className="status">
            <img
              src={infoImg}
              alt=""
              style={{ marginRight: 5, display: 'block' }}
            />
            <div>
              This Merchant has not yet verified or activated their account.
              Please contact merchant.
            </div>
          </div>
        )}
        <div className="card">
          <div className="container">
            <svg width="99px" height="33px" viewBox="0 0 99 33" version="1.1">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                  <path
                    d="M9,25.5 C4.037,25.5 0,21.462 0,16.5 L0,1.5 L6,0 L6,16.5 C6,18.154 7.346,19.5 9,19.5 L9,21.5 C6.243,21.5 4,19.257 4,16.5 L4,3 L2,3.5 L2,16.5 C2,20.36 5.141,23.5 9,23.5 L9,25.5 Z"
                    id="Fill-1"
                    fill="#2A365F"
                  />
                  <path
                    d="M4,26.2856 C4.634,26.6106 5.303,26.8756 6,27.0736 L6,24.9746 C5.29,24.7226 4.616,24.3916 4,23.9786 L4,26.2856 Z M0,22.8046 C0.569,23.6146 1.239,24.3486 2,24.9786 L2,22.1446 C0.751,20.5986 0,18.6366 0,16.4996 L0,22.8046 Z M6,8.0326 L6,10.1896 C6.633,9.8886 7.305,9.6766 8,9.5766 L8,7.5656 C7.315,7.6416 6.647,7.8046 6,8.0326 L6,8.0326 Z M6,15.4996 L6.184,15.4996 C6.486,14.6526 7.153,13.9866 8,13.6846 L8,11.6006 C7.256,11.7526 6.584,12.0836 6,12.5256 L6,15.4996 Z"
                    id="Fill-3"
                    fill="#4EA162"
                  />
                  <path
                    d="M4,30 L2,29.5 L2,24.979 C1.239,24.349 0.569,23.615 0,22.805 L0,31.5 L6,33 L6,27.073 C5.303,26.875 4.634,26.611 4,26.286 L4,30 Z M9,7.5 C8.665,7.5 8.332,7.529 8,7.566 L8,9.577 C8.331,9.529 8.664,9.5 9,9.5 C12.859,9.5 16,12.64 16,16.5 C16,20.36 12.859,23.5 9,23.5 L9,25.5 C13.963,25.5 18,21.462 18,16.5 C18,11.538 13.963,7.5 9,7.5 M12,16.5 C12,18.154 10.654,19.5 9,19.5 L9,21.5 C11.757,21.5 14,19.257 14,16.5 C14,13.743 11.757,11.5 9,11.5 C8.658,11.5 8.323,11.535 8,11.601 L8,13.684 C8.314,13.572 8.647,13.5 9,13.5 C10.654,13.5 12,14.846 12,16.5"
                    id="Fill-7"
                    fill="#6EC177"
                  />
                  <polygon
                    id="Fill-1"
                    fill="#2A365F"
                    points="25 7.2622 25 23.8332 27.667 23.8332 27.667 6.5002"
                  />
                  <path
                    d="M31.6915,17.5161 C31.6915,18.0851 31.7945,18.6161 32.0015,19.1071 C32.2075,19.5981 32.4875,20.0211 32.8415,20.3741 C33.1945,20.7281 33.6165,21.0081 34.1085,21.2141 C34.5985,21.4211 35.1395,21.5231 35.7295,21.5231 C36.3175,21.5231 36.8635,21.4211 37.3635,21.2141 C37.8645,21.0081 38.2975,20.7231 38.6605,20.3601 C39.0235,19.9961 39.3035,19.5741 39.5005,19.0931 C39.6965,18.6111 39.7955,18.0851 39.7955,17.5161 C39.7955,16.9461 39.6965,16.4211 39.5005,15.9391 C39.3035,15.4581 39.0235,15.0401 38.6605,14.6861 C38.2975,14.3331 37.8645,14.0531 37.3635,13.8461 C36.8635,13.6401 36.3175,13.5381 35.7295,13.5381 C35.1395,13.5381 34.5985,13.6401 34.1085,13.8461 C33.6165,14.0531 33.1945,14.3331 32.8415,14.6861 C32.4875,15.0401 32.2075,15.4581 32.0015,15.9391 C31.7945,16.4211 31.6915,16.9461 31.6915,17.5161 Z M29.1575,17.6631 C29.1575,16.7591 29.3285,15.9101 29.6735,15.1141 C30.0165,14.3181 30.4825,13.6211 31.0725,13.0221 C31.6615,12.4221 32.3445,11.9461 33.1205,11.5921 C33.8965,11.2381 34.7265,11.0621 35.6105,11.0621 C36.2005,11.0621 36.7405,11.1361 37.2315,11.2831 C37.7225,11.4311 38.1445,11.6121 38.4985,11.8281 C38.8525,12.0441 39.1375,12.2701 39.3535,12.5061 C39.5695,12.7421 39.7165,12.9481 39.7955,13.1251 L39.9135,11.1661 L42.3335,11.1661 L42.3335,23.8331 L39.6665,23.8331 L39.7955,22.1421 C39.6965,22.2991 39.5405,22.4861 39.3245,22.7021 C39.1075,22.9191 38.8275,23.1201 38.4835,23.3071 C38.1405,23.4931 37.7325,23.6551 37.2615,23.7931 C36.7895,23.9301 36.2495,23.9991 35.6405,23.9991 C34.6965,23.9991 33.8285,23.8261 33.0325,23.4831 C32.2365,23.1391 31.5535,22.6771 30.9845,22.0981 C30.4145,21.5191 29.9675,20.8461 29.6435,20.0801 C29.3195,19.3131 29.1575,18.5081 29.1575,17.6631 Z"
                    id="Fill-2"
                    fill="#2A365F"
                  />
                  <path
                    d="M51.3942,6.1505 C51.3942,5.6795 51.5652,5.2865 51.9102,4.9715 C52.2532,4.6575 52.6212,4.5005 53.0142,4.5005 C53.4072,4.5005 53.7702,4.6575 54.1052,4.9715 C54.4382,5.2865 54.6062,5.6795 54.6062,6.1505 C54.6062,6.6215 54.4382,7.0095 54.1052,7.3145 C53.7702,7.6185 53.4072,7.7715 53.0142,7.7715 C52.6212,7.7715 52.2532,7.6185 51.9102,7.3145 C51.5652,7.0095 51.3942,6.6215 51.3942,6.1505"
                    id="Fill-4"
                    fill="#2A365F"
                  />
                  <polygon
                    id="Fill-6"
                    fill="#2A365F"
                    points="51.666 23.8333 54.333 23.8333 54.333 11.1663 51.666 11.1663"
                  />
                  <path
                    d="M47,19.1243 L47,13.4063 L49,13.4063 L50.176,11.1663 L47,11.1663 L47,6.5003 L44.371,7.1663 L44.371,19.1243 C44.371,22.3793 46.137,24.8323 50.176,23.7043 L50.176,21.3553 L50.17,21.3423 C48.266,21.9893 47,21.6483 47,19.1243"
                    id="Fill-8"
                    fill="#2A365F"
                  />
                  <path
                    d="M66.8165,17.5161 C66.8165,16.9461 66.7275,16.4211 66.5515,15.9391 C66.3735,15.4581 66.1185,15.0401 65.7855,14.6861 C65.4505,14.3331 65.0475,14.0531 64.5765,13.8461 C64.1055,13.6401 63.5745,13.5381 62.9855,13.5381 C62.3955,13.5381 61.8515,13.6401 61.3495,13.8461 C60.8485,14.0531 60.4215,14.3331 60.0675,14.6861 C59.7145,15.0401 59.4345,15.4581 59.2275,15.9391 C59.0215,16.4211 58.9185,16.9461 58.9185,17.5161 C58.9185,18.0851 59.0215,18.6161 59.2275,19.1071 C59.4345,19.5981 59.7145,20.0211 60.0675,20.3741 C60.4215,20.7281 60.8485,21.0081 61.3495,21.2141 C61.8515,21.4211 62.3955,21.5231 62.9855,21.5231 C63.5745,21.5231 64.1055,21.4211 64.5765,21.2141 C65.0475,21.0081 65.4505,20.7231 65.7855,20.3601 C66.1185,19.9961 66.3735,19.5741 66.5515,19.0931 C66.7275,18.6111 66.8165,18.0851 66.8165,17.5161 M69.5565,17.5741 C69.5565,18.4981 69.3995,19.3531 69.0855,20.1391 C68.7715,20.9241 68.3285,21.6031 67.7595,22.1721 C67.1895,22.7421 66.5065,23.1881 65.7115,23.5131 C64.9155,23.8361 64.0455,23.9991 63.1035,23.9991 C62.6115,23.9991 62.1455,23.9441 61.7035,23.8361 C61.2615,23.7281 60.8535,23.5821 60.4805,23.3951 C60.1075,23.2081 59.7825,23.0021 59.5075,22.7761 C59.2325,22.5501 59.0265,22.3191 58.8895,22.0831 C58.8895,22.1821 58.9995,22.6041 58.9995,22.7021 L58.9995,29.8331 L56.3335,29.1661 L56.3335,11.1661 L58.8305,11.1661 C58.8305,11.4021 58.9185,12.9091 58.9185,13.1841 C59.0755,12.9481 59.2865,12.7081 59.5515,12.4621 C59.8175,12.2161 60.1315,11.9911 60.4955,11.7841 C60.8585,11.5781 61.2665,11.4061 61.7185,11.2681 C62.1695,11.1311 62.6705,11.0621 63.2205,11.0621 C64.1645,11.0621 65.0225,11.2141 65.7995,11.5181 C66.5755,11.8231 67.2435,12.2561 67.8035,12.8151 C68.3635,13.3751 68.7955,14.0581 69.1005,14.8641 C69.4045,15.6701 69.5565,16.5731 69.5565,17.5741"
                    id="Fill-9"
                    fill="#6EC177"
                  />
                  <path
                    d="M73.0288,17.5161 C73.0288,18.0851 73.1318,18.6161 73.3388,19.1071 C73.5448,19.5981 73.8248,20.0211 74.1788,20.3741 C74.5318,20.7281 74.9538,21.0081 75.4458,21.2141 C75.9358,21.4211 76.4768,21.5231 77.0668,21.5231 C77.6548,21.5231 78.2008,21.4211 78.7008,21.2141 C79.2018,21.0081 79.6348,20.7231 79.9978,20.3601 C80.3608,19.9961 80.6408,19.5741 80.8378,19.0931 C81.0338,18.6111 81.1328,18.0851 81.1328,17.5161 C81.1328,16.9461 81.0338,16.4211 80.8378,15.9391 C80.6408,15.4581 80.3608,15.0401 79.9978,14.6861 C79.6348,14.3331 79.2018,14.0531 78.7008,13.8461 C78.2008,13.6401 77.6548,13.5381 77.0668,13.5381 C76.4768,13.5381 75.9358,13.6401 75.4458,13.8461 C74.9538,14.0531 74.5318,14.3331 74.1788,14.6861 C73.8248,15.0401 73.5448,15.4581 73.3388,15.9391 C73.1318,16.4211 73.0288,16.9461 73.0288,17.5161 M70.4948,17.6631 C70.4948,16.7591 70.6658,15.9101 71.0108,15.1141 C71.3538,14.3181 71.8198,13.6211 72.4098,13.0221 C72.9988,12.4221 73.6818,11.9461 74.4578,11.5921 C75.2338,11.2381 76.0638,11.0621 76.9478,11.0621 C77.5378,11.0621 78.0778,11.1361 78.5688,11.2831 C79.0598,11.4311 79.4818,11.6121 79.8358,11.8281 C80.1898,12.0441 80.4748,12.2701 80.6908,12.5061 C80.9068,12.7421 81.0538,12.9481 81.1328,13.1251 L81.2508,11.1661 L83.6668,11.1661 L83.6668,23.8331 L80.9998,23.8331 L81.1328,22.1421 C81.0338,22.2991 80.8778,22.4861 80.6618,22.7021 C80.4448,22.9191 80.1648,23.1201 79.8208,23.3071 C79.4778,23.4931 79.0698,23.6551 78.5988,23.7931 C78.1268,23.9301 77.5868,23.9991 76.9778,23.9991 C76.0338,23.9991 75.1658,23.8261 74.3698,23.4831 C73.5738,23.1391 72.8908,22.6771 72.3218,22.0981 C71.7518,21.5191 71.3048,20.8461 70.9808,20.0801 C70.6568,19.3131 70.4948,18.5081 70.4948,17.6631"
                    id="Fill-10"
                    fill="#6EC177"
                  />
                  <polygon
                    id="Fill-11"
                    fill="#6EC177"
                    points="94.8434 11.1666 91.1464 19.4356 87.4554 11.1666 84.6604 11.1666 89.7514 22.4716 89.7514 22.4716 87.0154 28.8336 90.0004 28.8336 97.6324 11.1666"
                  />
                </g>
              </g>
            </svg>
            <div className="img-top-right">
              <svg
                width="122px"
                height="51px"
                viewBox="0 0 122 51"
                version="1.1"
              >
                <defs>
                  <rect id="path-1" x="0" y="0" width="351" height="684" />
                  <linearGradient
                    x1="50%"
                    y1="0%"
                    x2="50%"
                    y2="100%"
                    id="linearGradient-3"
                  >
                    <stop stopColor="#FFC663" offset="0%" />
                    <stop stopColor="#FFD97D" offset="100%" />
                  </linearGradient>
                  <linearGradient
                    x1="29.710297%"
                    y1="15.2103253%"
                    x2="70.1654082%"
                    y2="93.6131328%"
                    id="linearGradient-4"
                  >
                    <stop stopColor="#FEC25F" offset="0%" />
                    <stop stopColor="#FFD97D" offset="100%" />
                  </linearGradient>
                </defs>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g transform="translate(-241.000000, -109.000000)">
                    <rect fill="#F3F4F5" x="0" y="0" width="375" height="812" />
                    <g transform="translate(12.000000, 109.000000)">
                      <mask id="mask-2" fill="white">
                        <use xlinkHref="#path-1" />
                      </mask>
                      <use fill="#FFFFFF" xlinkHref="#path-1" />
                      <circle
                        id="Oval"
                        fill="url(#linearGradient-3)"
                        mask="url(#mask-2)"
                        cx="343.5"
                        cy="-63.5"
                        r="112.5"
                      />
                      <circle
                        id="Oval备份"
                        fill="url(#linearGradient-4)"
                        mask="url(#mask-2)"
                        cx="242"
                        cy="38"
                        r="13"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div>
              <div className="merchant-name">
                {qrName}
                {false && !accountCode && <div className="loader" />}
              </div>
              {rate &&
                rate > 0 && <div className="rate">Exchange rate {rate}</div>}

              <form>
                <div
                  className={`dark-card amount-card ${
                    amountError ? 'amount-card__error' : ''
                  }`}
                >
                  <label className="new-currency" htmlFor="amount">
                    Amount {currency ? `(${currency})` : ''}
                  </label>
                  {fixedAmount && (
                    <input
                      className="amount"
                      type="number"
                      value={
                        gateway === 'coin_payments'
                          ? numeral(fixedAmount).format('0.00000')
                          : numeral(fixedAmount).format('0.00')
                      }
                      disabled
                    />
                  )}
                  {!fixedAmount &&
                    data.shortCode && (
                      <input
                        id="amount"
                        className="amount"
                        type="number"
                        placeholder={placeholder}
                        value={amount}
                        max="1000000"
                        step={gateway === 'coin_payments' ? '0.00001' : '0.01'}
                        onChange={this.change('amount')}
                        onBlur={this.onBlur}
                        onFocus={this.onFocus}
                        autoComplete="off"
                        ref={this.amountRef}
                      />
                    )}

                  {selectGateway &&
                    selectGateway.charge >= 0 && (
                      <div className="service-fee">
                        {selectGateway.charge > 0 && (
                          <span>
                            {`Service fee ${selectGateway.charge}%` +
                              (selectGateway.charge > 0 &&
                              selectGateway.maxCharge > 0
                                ? `, capped at $${selectGateway.maxCharge}`
                                : '')}
                          </span>
                        )}
                        {selectGateway.charge === 0 && (
                          <span>Zero Transaction Fee</span>
                        )}

                        {!hideFeeTips &&
                          selectGateway.charge > 0 && (
                            <img
                              style={{
                                verticalAlign: 'sub',
                                marginLeft: '5px'
                              }}
                              src={helpLogo}
                              onClick={this.showHelp}
                              alt=""
                            />
                          )}

                        {showHelp && (
                          <div>
                            Latitude Technologies Limited (Latipay) does not
                            charge any fee through this payment transaction!
                          </div>
                        )}
                      </div>
                    )}
                </div>

                {referenceTemplate && (
                  <div className="dark-card reference">
                    {payerReference && (
                      <div className="payer-reference">
                        <div
                          style={{
                            display: 'flex',
                            marginBottom: 5
                          }}
                        >
                          <svg
                            width="16px"
                            height="16px"
                            viewBox="0 0 16 16"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <defs>
                              <rect
                                id="path-1"
                                x="0"
                                y="0"
                                width="351"
                                height="771"
                                rx="15"
                              />
                              <rect
                                id="path-3"
                                x="1"
                                y="0"
                                width="315"
                                height="175"
                                rx="6"
                              />
                              <filter
                                x="-0.5%"
                                y="-0.9%"
                                width="101.0%"
                                height="101.7%"
                                filterUnits="objectBoundingBox"
                                id="filter-4"
                              >
                                <feGaussianBlur
                                  stdDeviation="1"
                                  in="SourceAlpha"
                                  result="shadowBlurInner1"
                                />
                                <feOffset
                                  dx="0"
                                  dy="1"
                                  in="shadowBlurInner1"
                                  result="shadowOffsetInner1"
                                />
                                <feComposite
                                  in="shadowOffsetInner1"
                                  in2="SourceAlpha"
                                  operator="arithmetic"
                                  k2="-1"
                                  k3="1"
                                  result="shadowInnerInner1"
                                />
                                <feColorMatrix
                                  values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0"
                                  type="matrix"
                                  in="shadowInnerInner1"
                                />
                              </filter>
                            </defs>
                            <g
                              id="页面-1"
                              stroke="none"
                              strokeWidth="1"
                              fill="none"
                              fillRule="evenodd"
                            >
                              <g
                                id="支付-必填"
                                transform="translate(-43.000000, -290.000000)"
                              >
                                <g
                                  id="编组-2"
                                  transform="translate(12.000000, 47.000000)"
                                >
                                  <g id="编组-14">
                                    <mask id="mask-2" fill="white">
                                      <use xlinkHref="#path-1" />
                                    </mask>
                                    <use
                                      id="蒙版"
                                      fill="#FFFFFF"
                                      xlinkHref="#path-1"
                                    />
                                  </g>
                                  <g
                                    id="编组-3备份"
                                    transform="translate(18.000000, 230.000000)"
                                  >
                                    <g id="矩形备份" opacity="0.361816406">
                                      <use
                                        fill="#EBEBEB"
                                        fillRule="evenodd"
                                        xlinkHref="#path-3"
                                      />
                                      <use
                                        fill="black"
                                        fillOpacity="1"
                                        filter="url(#filter-4)"
                                        xlinkHref="#path-3"
                                      />
                                    </g>
                                    <g
                                      id="消息"
                                      transform="translate(21.000000, 21.000000) scale(-1, 1) translate(-21.000000, -21.000000) translate(13.000000, 13.000000)"
                                      fillRule="nonzero"
                                    >
                                      <rect
                                        id="矩形"
                                        fill="#000000"
                                        opacity="0"
                                        x="0"
                                        y="0"
                                        width="16"
                                        height="16"
                                      />
                                      <path
                                        d="M9.5,2 C13.0897727,2 16,4.68628571 16,8 C15.9979295,9.09097613 15.6758213,10.1589959 15.0710909,11.08 L15.4090909,13.3685714 C15.4090909,13.7171429 15.1165909,14 14.7561364,14 L11.8305455,13.596 C11.1066818,13.8531429 10.3225455,14 9.5,14 C5.91022728,14 3,11.3137143 3,8 C3,4.68628571 5.91022728,2 9.5,2 Z M9.5,3 C6.46705556,3 4,5.24294118 4,8 C4,10.7570588 6.46705556,13 9.5,13 C10.1789808,12.9994383 10.8524731,12.8829269 11.4891667,12.6558824 L11.7782222,12.5535294 L12.0831667,12.5952941 L14.2831667,12.8982353 L14.0515556,11.3364706 L13.988,10.9088235 L14.2263333,10.5435294 C14.7286259,9.78304194 14.9968674,8.90116302 15,8 C15,5.24294118 12.5329444,3 9.5,3 Z M6,8 L6,7 L12,7 L12,8 L6,8 Z M7,10 L7,9 L11,9 L11,10 L7,10 L7,10 Z"
                                        id="形状"
                                        fill="#68C371"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                          <span style={{ marginLeft: 3 }}>
                            Merchants Note：
                          </span>
                        </div>
                        <div>{payerReference}</div>
                      </div>
                    )}
                    <div
                      className="reference-btn"
                      onClick={this.openReference}
                      style={!payerReference ? { paddingTop: 15 } : {}}
                    >
                      <div>
                        Reference{' '}
                        {(particularsRequired ||
                          codeRequired ||
                          referenceRequired) &&
                          !(
                            referenceParticularError ||
                            referenceCodeError ||
                            referenceError
                          ) && <span className="red">*</span>}
                        {(referenceParticularError ||
                          referenceCodeError ||
                          referenceError) && (
                          <span className="red">(required)</span>
                        )}
                      </div>
                    </div>

                    {referenceOpened &&
                      referenceTemplate && (
                        <div className="reference-content">
                          {(particularsRequired || particularsHint) && (
                            <div>
                              <input
                                id="particulars"
                                placeholder={
                                  (particularsRequired ? '*' : '') +
                                  (particularsHint || 'Particulars')
                                }
                                className={
                                  referenceParticularError
                                    ? 'placeholder-red'
                                    : ''
                                }
                                value={particulars}
                                onChange={this.change('particulars')}
                                ref={this.referenceParticularRef}
                              />
                            </div>
                          )}

                          {(codeRequired || codeHint) && (
                            <div>
                              <input
                                id="code"
                                placeholder={
                                  (codeRequired ? '*' : '') +
                                  (codeHint || 'Code')
                                }
                                className={
                                  referenceCodeError ? 'placeholder-red' : ''
                                }
                                value={referenceCode}
                                onChange={this.change('referenceCode')}
                                ref={this.referenceCodeRef}
                              />
                            </div>
                          )}

                          {(!needReference ||
                            referenceRequired ||
                            referenceHint) && (
                            <div>
                              <input
                                id="reference"
                                placeholder={
                                  (referenceRequired ? '*' : '') +
                                  (referenceHint || 'Reference to payee')
                                }
                                className={
                                  referenceError ? 'placeholder-red' : ''
                                }
                                value={reference}
                                onChange={this.change('reference')}
                                ref={this.referenceRef}
                              />
                            </div>
                          )}
                        </div>
                      )}
                  </div>
                )}

                {gateways.map(item => (
                  <div
                    key={item.name}
                    className="gateway"
                    onClick={item.disabled ? null : this.select(item)}
                  >
                    <div className="flexed">
                      <img
                        style={{
                          height: '52px',
                          opacity: item.disabled ? 0.4 : 1
                        }}
                        src={icons[item.name.toLowerCase()]}
                        alt={titles[item.name] || item.name}
                      />
                      <div className="name">
                        <div>{titles[item.name]}</div>
                        {item.disabled && (
                          <div style={{ color: '#9b9b9b' }}>
                            Available after verified
                          </div>
                        )}

                        {item.name === 'wechat' &&
                          this.isForSaveQRCode() && (
                            <div className="gateway-tips green-tips">
                              请保存二维码并使用微信打开完成付款。
                            </div>
                          )}
                      </div>
                    </div>
                    {!item.disabled && (
                      <img
                        src={selectedLogo}
                        alt="selected"
                        style={{
                          display: item.name === gateway ? 'block' : 'none'
                        }}
                      />
                    )}
                    {!item.disabled && (
                      <img
                        src={unselectedLogo}
                        alt=""
                        style={{
                          display: item.name !== gateway ? 'block' : 'none'
                        }}
                      />
                    )}
                  </div>
                ))}

                <input
                  disabled={!enabled}
                  className={`btn ${enabled ? 'btn-enabled' : ''} ${
                    this.isForSaveQRCode() ? 'btn-green' : ''
                  }`}
                  type="button"
                  value={this.isForSaveQRCode() ? 'Save QR Code' : 'Pay'}
                  onClick={
                    this.isForSaveQRCode() ? this.downloadQRCode : this.submit
                  }
                />

                {submitting && (
                  <div
                    className="loader"
                    style={{
                      width: 18,
                      height: 18,
                      marginTop: -18,
                      position: 'relative',
                      top: -36,
                      left: 30
                    }}
                  />
                )}
              </form>

              <div style={{ height: '35px', width: '100%' }} />
              <Footer />
            </div>
          </div>
        </div>

        {openInSafari && (
          <div
            onClick={() => {
              this.setState({
                openInSafari: false
              });
            }}
          >
            <div id="open-in-safari">
              <div
                className="open-in-safari-pop"
                id="open-in-safari-pop-android"
              >
                <div dangerouslySetInnerHTML={{ __html: svg1 }} />
                <p style={{ marginTop: '10px' }}>
                  请使用浏览器打开
                  <br />
                  {isiOSPlatform && (
                    <span>
                      please <strong>Open in Safari</strong>
                    </span>
                  )}
                  {!isiOSPlatform && (
                    <span>
                      please <strong>Open with Browser</strong>
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/OfflineApiOrder/StaticQR2Form/index.js